import { useEffect, useState } from "react";

export type IconProps = {
  className?: string;
  fill?: string;
};

const AssessmentIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path d="M14.6654 16H1.33203V2C1.33203 0.897333 2.22936 0 3.33203 0H12.6654C13.768 0 14.6654 0.897333 14.6654 2V16ZM2.66536 14.6667H13.332V2C13.332 1.63267 13.0327 1.33333 12.6654 1.33333H3.33203C2.9647 1.33333 2.66536 1.63267 2.66536 2V14.6667ZM11.9987 3.33333H7.9987V4.66667H11.9987V3.33333ZM11.9987 7.33333H7.9987V8.66667H11.9987V7.33333ZM11.9987 11.3333H7.9987V12.6667H11.9987V11.3333ZM6.66536 2.66667H3.9987V5.33333H6.66536V2.66667ZM6.66536 6.66667H3.9987V9.33333H6.66536V6.66667ZM6.66536 10.6667H3.9987V13.3333H6.66536V10.6667Z" fill={fill}/>
    </svg>
  );
};

export default AssessmentIcon;
